// extracted by mini-css-extract-plugin
export default {"spinnerDual":"Spinner_spinnerDual__tu8kQ","spin":"Spinner_spin__qpakw","loader":"Spinner_loader__O9fR2"};